<template>
  <div>
    <v-dialog v-model="productSearchMatchingDialog" max-width="422">
      <v-card>
        <v-card-title class="pl-5 pt-5 pb-5"
          >[유료멤버십 서비스] 결제하기</v-card-title
        >
        <div>
          <div>
            <p class="mt-2 pl-5 mb-0 float-left" style="width:110px;">
              결제 금액
            </p>
          </div>

          <div>
            <v-text-field
              outlined
              single-line
              hide-details
              class="pl-5 mr-2 mb-0 col-5 float-left"
              v-model="charge_amount"
              dense
              style="width:268px;"
              @keydown="M.replaceCommaNumber($event, 15, false)"
              @keyup="M.replaceCommaNumber($event, 15, false)"
              disabled
            ></v-text-field>

            <p class="mt-2 mb-0 float-left mr-5">원</p>
          </div>
        </div>
        <div>
          <v-btn
            color="black"
            hide-details
            depressed
            class="white--text ml-5 mt-2"
            @click="productSearchMatchingDialog = false"
            width="159"
            >닫기</v-btn
          >

          <v-btn
            color="primary"
            hide-details
            class="white--text ml-2 mt-7 mb-5 pl-4 pr-4 mr-5"
            depressed
            @click="productSearchMatchingMatching()"
            width="215"
            >결제하기</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import Common from "@/libs/common.js";

export default {
  data: () => {
    return {
      M,
      productSearchMatchingDialog: false,
      productSearchMatchingModal: "",
      productSearchMatchingItems: [{ text: "상품분류명 선택", value: "" }],
      charge_amount: "2,200,000",
    };
  },
  methods: {
    show: function() {
      this.productSearchMatchingDialog = true;
    },

    productSearchMatchingMatching: async function() {
      let setData = {
        order_amount: Common.onlyNumber(this.charge_amount),
        order_name: "유료 멤버십 서비스",
        automatic_payment: "F",
      };
      let res = await M.api(M.entry("/post/membership/orders"), setData);
      window.open(res.confirmation_url, "_blank");
    },
  },
};
</script>
